import PropTypes from 'prop-types'

const TimeCircleBlue = ({
  width = '24',
  height = '24',
  className = '',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    {...{ ...props }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12.5" r="10" stroke="#137FC3" strokeWidth="1.5" />
    <path
      d="M12 8.5V12.2324C12 12.3996 12.0836 12.5557 12.2226 12.6484L15 14.5"
      stroke="#137FC3"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)

TimeCircleBlue.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
}

TimeCircleBlue.defaultProps = {
  width: '24',
  height: '24',
  className: '',
}

export default TimeCircleBlue
